const SAVE = "SAVE_NOTIFICATION_ITEM_ADDED";

export function save(data) {
    return {
        type: SAVE,
        payload: data
    }
}